import { useReveal } from '../hooks/useReveal';
import { getBlock } from '../content';

export default function FullbleedQuote() {
  const textRef  = useReveal();
  const videoRef = useReveal();
  const c = getBlock('home.quote');

  return (
    <section className="quote-split">
      <div className="quote-split-inner">
        <div className="quote-split-text reveal" ref={textRef}>
          <div className="quote-split-mark">"</div>
          <h2 className="quote-split-quote">{c.quote}</h2>
          <div className="quote-split-author">{c.author}</div>
        </div>

        <div className="quote-split-media reveal" ref={videoRef}>
          <video
            autoPlay muted loop playsInline
            preload="auto"
            disablePictureInPicture
            controlsList="nodownload nofullscreen noremoteplayback"
            aria-hidden="true"
            tabIndex={-1}
          >
            <source src={`${process.env.PUBLIC_URL}${c.video}`} type="video/mp4" />
          </video>
        </div>
      </div>
    </section>
  );
}
